import React from 'react';
import Dialog from '../../../../../Components/Dialog';
import { EXTENSION_DATA_DETAILS } from '../../constant';
import { ACTIVITY_TYPES_ICONS } from '../../../../../Utils/constants/activityTypes';
import { FullSizeFlexBox } from '../../../../../Components/FlexBox';

const DetailsDialog = function DetailsDialog({
  open,
  onClose,
  data,
  activityTypeName,
  activityTypes,
}) {
  const Icon = ACTIVITY_TYPES_ICONS[activityTypeName];
  const Content = EXTENSION_DATA_DETAILS[activityTypeName];
  return (
    <Dialog
      id={`details-dialog-${data?.name}`}
      open={open}
      onClose={onClose}
      icon={<Icon />}
      title="ACTIVITY_OUTCOME_DETAILS"
      width="sm"
      fullWidth
    >
      <FullSizeFlexBox padding="16px">
        <Content
          {...data}
          activityTypes={activityTypes}
          activityTypeName={activityTypeName}
        />
      </FullSizeFlexBox>
    </Dialog>
  );
};

export default DetailsDialog;
